<template>
  <v-container class="login-or-reg" fill-height fluid>
    <v-layout justify-center>
      <v-flex md4 sm8 xs12>
        <v-card style="margin-top:80px">
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                :rules="passwordRules"
                color="accent"
                disabled
                label="Username"
                v-model="$route.query.username"
              ></v-text-field>
              <v-text-field
                :rules="passwordRules"
                autocomplete="new-password"
                color="accent"
                label="Password"
                required
                type="password"
                v-model="form.password"
              ></v-text-field>
              <v-text-field
                :rules="confirmPasswordRules"
                autocomplete="confirm-password"
                color="success"
                label="Password confirmation"
                required
                type="password"
                v-model="form.confirmPassword"
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="update" color="primary" flat>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      message: '',
      passwordRules: [
        v => !!v || 'This is required',
        v => (v && v.length >= 8) || 'It should be a minimum of 8 characters'
      ],
      confirmPasswordRules: [
        v => !!v || 'This is required',
        v =>
          (v && v === this.form.password) ||
          'The password confirmation does not match'
      ],
      form: {
        password: null,
        confirmPassword: null
      }
    }
  },
  methods: {
    update() {
      if (this.$refs.form.validate()) {
        return this.$http
          .patch('/basic-data/user-accounts', {
            user_name: this.$route.query.username,
            password: this.employee.username
          })
          .then(res => {
            if (res.data.ret_code === '00000') {
              this.employee.userAccountId =
                res.data.addition_data.user_account_id
            }
            return this.employee
          })
      }
    }
  }
}
</script>
